// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../common/Components/IconV5.bs.js");
let Tooltip = require("../../common/Components/Tooltip.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let WizardFormUtils = require("../../common/Form/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertySearchResultTitle = require("../../common/Components/PropertySearchResultTitle.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let DevelopmentSampleUnitSummary = require("../../common/Development/DevelopmentSampleUnitSummary.bs.js");
let DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.bs.js");

let convertFragment = DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment_developmentProjectUnitType_decode = DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.Utils.developmentProjectUnitType_decode;

let UnitFragment_developmentProjectUnitType_fromString = DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.Utils.developmentProjectUnitType_fromString;

let UnitFragment = {
  developmentProjectUnitType_decode: UnitFragment_developmentProjectUnitType_decode,
  developmentProjectUnitType_fromString: UnitFragment_developmentProjectUnitType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResultTitleAndLocation(props) {
  let unit = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit_graphql.node, convertFragment, props.unit);
  let title = DevelopmentSampleUnitSummary.title(unit.unitType, unit.name);
  let match = unit.location;
  let tmp;
  if (match !== undefined) {
    let exit = 0;
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
      case "PropertyLocationWithVisibleAddress" :
        exit = 1;
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(match._0);
        break;
    }
    if (exit === 1) {
      tmp = JsxRuntime.jsx("div", {
        children: match.locationDisplay,
        className: "text-zinc-600 text-lg font-normal"
      });
    }
  } else {
    tmp = null;
  }
  let name = WizardFormUtils.noneIfEmpty(unit.development.name);
  return JsxRuntime.jsxs(ViewStack.make, {
    space: "xs",
    children: [
      JsxRuntime.jsx(PropertySearchResultTitle.make, {
        detailsHref: props.detailsHref,
        children: title
      }),
      tmp,
      name !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Tooltip.make, {
            label: "This is a sample unit for the development project, not a live listed unit.\nAvailability, pricing, and details may change.",
            preserveLineBreaks: true,
            children: JsxRuntime.jsxs("span", {
              children: [
                JsxRuntime.jsx("span", {
                  children: name,
                  className: "underline decoration-dotted decoration-zinc-400"
                }),
                JsxRuntime.jsx(IconV5.make, {
                  icon: "question",
                  size: 15,
                  className: "text-zinc-500"
                })
              ],
              className: "inline-flex items-center gap-1.5"
            })
          }),
          className: "mt-2 mb-1.5 text-zinc-600 text-lg font-normal leading-snug"
        }) : null
    ]
  });
}

let make = DevelopmentUnitSearchResultTitleAndLocation;

exports.UnitFragment = UnitFragment;
exports.make = make;
/* IconV5 Not a pure module */
